/** Shared delete flow for lifecycle policy screens (onboarding, confirmation, transfer, separation). */

export const extractDeleteImpactFromError = (error) => {
  const data = error?.response?.data;
  if (!data) return null;
  if (data.data && typeof data.data.pendingTotal === "number") return data.data;
  if (typeof data.pendingTotal === "number") return data;
  return null;
};

export const startPolicyDeleteFlow = async ({
  policyId,
  policyName,
  getDeleteImpact,
  setDeleteModal,
  onError,
}) => {
  try {
    const res = await getDeleteImpact(policyId);
    if (!res?.success) {
      onError?.(res?.message || "Could not check delete impact");
      return;
    }
    const impact = res.data;
    if (!impact.canDelete) {
      setDeleteModal({ mode: "blocked", policyId, policyName, impact });
      return;
    }
    setDeleteModal({ mode: "confirm", policyId, policyName, impact });
  } catch (error) {
    const blocked = extractDeleteImpactFromError(error);
    if (blocked && blocked.pendingTotal > 0) {
      setDeleteModal({ mode: "blocked", policyId, policyName, impact: blocked });
      return;
    }
    onError?.(error?.response?.data?.message || error?.message || "Could not check delete impact");
  }
};

export const confirmPolicyDelete = async ({
  policyId,
  deletePolicy,
  setDeleting,
  onSuccess,
  onError,
  setDeleteModal,
}) => {
  setDeleting(true);
  try {
    const res = await deletePolicy(policyId);
    if (res?.success) {
      setDeleteModal(null);
      onSuccess?.();
      return;
    }
    onError?.(res?.message || "Failed to delete policy");
  } catch (error) {
    const blocked = extractDeleteImpactFromError(error);
    if (blocked && blocked.pendingTotal > 0) {
      setDeleteModal((prev) =>
        prev
          ? { ...prev, mode: "blocked", impact: blocked }
          : { mode: "blocked", policyId, impact: blocked }
      );
      return;
    }
    onError?.(error?.response?.data?.message || error?.message || "Failed to delete policy");
  } finally {
    setDeleting(false);
  }
};
